import React from "react";
import { Col, Row } from "react-bootstrap";

type Props = {
  title: string;
  renderDescription: () => JSX.Element;
  renderMainBtn: () => JSX.Element;
  renderSecondaryBtn: () => JSX.Element;
  renderLinks: () => JSX.Element[];
  imgAlt: string;
  imgSrc: string;
};
export const EmptyState: React.SFC<Props> = ({
  title,
  renderDescription,
  renderMainBtn,
  renderSecondaryBtn,
  renderLinks,
  imgAlt,
  imgSrc,
}) => {
  return (
    <Row className="align-items-center">
      <Col md="8">
        <div className="text-center justify-content-center">
          <div className="h3">{title}</div>
          <div className="h5 text-muted justify-content-center">
            {renderDescription()}
          </div>
          <Row className="justify-content-center my-4 align-items-center">
            {renderMainBtn()}
            <div className="ml-2">{renderSecondaryBtn()}</div>
          </Row>

          {renderLinks().map((l, i) => (
            <Row key={i} className="justify-content-center">
              {l}
            </Row>
          ))}
        </div>
      </Col>
      <Col md="4">
        <div className="text-center">
          <img width="150px" alt={imgAlt} src={imgSrc} />
        </div>
      </Col>
    </Row>
  );
};
export default EmptyState;
